import { FC } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const Loader: FC = () => {
  return (
    <Box
      sx={{
        ...sxColumnCenter,
        height: "100%",
        width: "100%",
      }}
    >
      <CircularProgress />
      <Typography mt={2}>Loading ...</Typography>
    </Box>
  );
};

export default Loader;

const sxColumnCenter = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};
